//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from '@/api/PMS/baseInformation/roomcustomer';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      areaId: '',
      list: [],
      total: '',
      listQuery: {
        limit: 10,
        page: 1
      },
      listLoading: false
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.houseId = this.keyValue;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.initSearch = false;
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.initSearch = false;
      this.listQuery.page = val;
      this.getList();
    }
  }
};